import React, { useMemo } from 'react'
import { Area, AreaChart, CartesianGrid, ResponsiveContainer } from 'recharts'

import { ChartTooltip, XAxis, YAxis } from '../../components'

import { useMediaQuery } from '../../hooks'
import { GraphComponentProps, GraphPayload } from '../../types'
import { areDatesEqual } from '../../helpers'

type Props = Pick<GraphComponentProps, 'graphHeight'> & {
  data?: {
    ad_count: GraphPayload
    ad_expenses: GraphPayload
  }
}

const DoubleCompanyChart: React.FC<Props> = ({ data, graphHeight }) => {
  const displayType = useMediaQuery()

  const monthlyInterval = useMemo(() => {
    if (data && data.ad_count?.length > 20) {
      return Math.floor(data.ad_count?.length / 20)
    }
    return 0
  }, [data])

  const getMonthFormat = () => {
    switch (displayType) {
      case 'mobile':
        return 'one'
      default:
        return 'three'
    }
  }

  const formattedData = data?.ad_count?.map(({ date, value }) => ({
    date,
    expenses: Number(
      data?.ad_expenses.find(element => areDatesEqual(element.date, date))?.value
    ).toFixed(1),
    count: value
  }))

  const expensesAxisDomain = [
    0,
    Math.round(
      (formattedData ? Math.max(...formattedData.map(({ expenses }) => Number(expenses))) : 0) *
        1.05
    )
  ]

  const countAxisDomain = [
    0,
    Math.round(
      (formattedData ? Math.max(...formattedData.map(({ count }) => Number(count))) : 0) * 1.1
    )
  ]

  return (
    <ResponsiveContainer width={'99%'} height={graphHeight}>
      <AreaChart data={formattedData} margin={{ left: -40, top: 0 }}>
        <defs>
          <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#C88CF2" stopOpacity={0.2} />
            <stop offset="1" stopColor="#C88CF2" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#3A64F8" stopOpacity={0.2} />
            <stop offset="1" stopColor="#3A64F8" stopOpacity={0} />
          </linearGradient>
        </defs>
        {/* TODO: чел просто решил фукнцию юзать вместо функционального компонента, переделать в нескольких местах */}
        {XAxis({ monthFormat: getMonthFormat(), monthlyInterval })}
        {YAxis({ dataKey: 'count', name: 'count', domain: countAxisDomain })}
        {YAxis({
          dataKey: 'expenses',
          name: 'expenses',
          yAxisId: 'expenses',
          orientation: 'right',
          minTickGap: 50,
          domain: expensesAxisDomain,
          unit: '€'
        })}
        <CartesianGrid stroke="#E0E3EB" strokeDasharray="5 5" />
        {ChartTooltip({ cursor: { stroke: '#292E3D', strokeDasharray: '5 5' } })}
        <Area
          type="monotone"
          strokeWidth={2}
          fillOpacity={1}
          activeDot={{ r: 7.5, strokeWidth: 2 }}
          dataKey="count"
          stroke="#C88CF2"
          fill="url(#colorUv)"
        />
        <Area
          type="monotone"
          strokeWidth={2}
          fillOpacity={1}
          activeDot={{ r: 7.5, strokeWidth: 2 }}
          dataKey="expenses"
          stroke="#3A64F8"
          fill="url(#colorPv)"
          yAxisId="expenses"
          unit="€"
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default DoubleCompanyChart
